import { extractTextFromQuery } from '../../../utils/query';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const email = text.trim();

    if (email) {
      return {
        email: {
          $ilike: `%${email}%`
        }
      }
    }
  }
}
